module.exports = __webpack_public_path__ + "img/gxjn.2cf0ec6.png";